<template>
  <!-- 展示部分 -->
  <div v-if="allInBool" class="kc-xy-show">
    <div class="pharmacy" v-for="(itemTwo, textTwo) in drugList.slice(0, 3)" :key="textTwo">
      <div class="pharmacyTitle">
        <span>{{ itemTwo.drugName }}</span>
        <span>{{ ' ' + '×' + itemTwo.amount }}</span>
        <span>{{ ' ' + (itemTwo.packageUnitValue || itemTwo.packageUnit) }}</span>
      </div>
      <div class="pharmacyText">
        <span>规格：</span>
        <span>{{ itemTwo.drugSpec }}</span>
      </div>
      <div class="pharmacyText">
        <span>用法：</span>
        <span>{{
          itemTwo.drugUsage.indexOf('m') != -1
            ? getKeyValueText('drug_usage_meng_his', itemTwo.drugUsage)
            : getKeyValueText('drug_usage_his', itemTwo.drugUsage)
        }}</span>
        <span
          >{{
            '，' + itemTwo.useAuantity + (itemTwo.measureUnitValue || itemTwo.measureUnit) + '，'
          }}
        </span>
        <span>{{ getKeyValueText('frequence_his', itemTwo.frequence) }} </span>
      </div>
      <div class="pharmacyText" v-if="itemTwo.attention">
        <span>嘱托：</span>
        <span>{{ itemTwo.attention || '- -' }}</span>
      </div>
    </div>
  </div>
  <!-- 展示全部 -->
  <div v-else class="kc-xy-show">
    <div class="pharmacy" v-for="(itemTwo, textTwo) in drugList" :key="textTwo">
      <div class="pharmacyTitle">
        <span>{{ itemTwo.drugName }}</span>
        <span>{{ ' ' + '×' + itemTwo.amount }}</span>
        <span>{{ ' ' + (itemTwo.packageUnitValue || itemTwo.packageUnit) }}</span>
      </div>
      <div class="pharmacyText">
        <span>规格：</span>
        <span>{{ itemTwo.drugSpec }}</span>
      </div>
      <div class="pharmacyText">
        <span>用法：</span>
        <span>{{
          itemTwo.drugUsage.indexOf('m') != -1
            ? getKeyValueText('drug_usage_meng_his', itemTwo.drugUsage)
            : getKeyValueText('drug_usage_his', itemTwo.drugUsage)
        }}</span>
        <span
          >{{
            '，' + itemTwo.useAuantity + (itemTwo.measureUnitValue || itemTwo.measureUnit) + '，'
          }}
        </span>
        <span>{{ getKeyValueText('frequence_his', itemTwo.frequence) }} </span>
      </div>
      <div class="pharmacyText" v-if="itemTwo.attention">
        <span>嘱托：</span>
        <span>{{ itemTwo.attention || '- -' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeyValueText } from './utils/index'

export default {
  props: {
    drugList: {
      type: Array,
      default: () => {
        return []
      }
    },
    allInBool: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  watch: {
    allInBool: {
      handler(val) {},
      immediate: true
    }
  },
  methods: {
    getKeyValueText
  }
}
</script>

<style lang="scss" scoped>
.pharmacy {
  width: 100%;
  border-bottom: 0.021333rem solid #ececec;
  font-size: 0.64rem;
  padding: 0.682667rem 0 0.682667rem 0;

  .pharmacyTitle {
    color: #222;
    padding-left: 0.682667rem;
  }

  .pharmacyText {
    color: #888888;
    padding: 0.682667rem 0 0 0.682667rem;
  }
}
</style>
